import { render, staticRenderFns } from "./EditConfigNumberInformation.vue?vue&type=template&id=157ea09f"
import script from "./EditConfigNumberInformation.vue?vue&type=script&lang=js"
export * from "./EditConfigNumberInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports